export default "assets/images/icons/triangle-fa402131.svg";